<template>
	<div v-if="showFiche">
		<div class="text-center buttonFicheDiv">
			<button
				type="button"
				class="dynvibeButton buttonFiche"
				data-toggle="modal"
				data-target="#dynvibeFiche"
				:data-idprofile="idprofile"
				@click="loadModal"
			>
				Fiche
				<i class="fas fa-lg fa-portrait"></i>
			</button>
		</div>
		<div v-if="showModal">
			<!-- <teleport to="#fiche-modal"> -->
			<transition name="modal">
				<div class="modal-mask modal">
					<div class="modal-wrapper" @click="showModal = false">
						<div class="modal-dialog modal-lg">
							<div class="modal-content" @click.stop>
								<div class="modal-header">
									<div class="col-lg-12 dynvibeTitleBox dynvibeTitleModal">
										<h5 class="modal-title">
											Fiche
											<button type="button" class="close" @click="showModal = false">
												<span aria-hidden="true">
													<i class="icon-x"></i>
												</span>
											</button>
										</h5>
									</div>
								</div>
								<div class="modal-body">
									<div class="dynvibeBox">
										<div class="row dynvibeRow">
											<div class="col-lg-12 dynvibeTitleBox">
												<h2>Medias</h2>
											</div>
										</div>
										<div v-if="sources.length > 1" class="row rowFilters">
											<div class="col-lg-12">
												<button
													class="dynvibeButton filterMediasButton"
													v-on:click="
														selectedSource = 'all';
														mediaFilter();
													"
												>
													All
												</button>
												<button
													v-for="(source, index) in sources"
													:key="index"
													class="dynvibeButton filterMediasButton"
													v-on:click="
														selectedSource = source;
														mediaFilter();
													"
												>
													{{ source }}</button
												>&nbsp;
											</div>
										</div>
										<div class="row dynvibeRow">
											<div class="col-lg-12">
												<div v-if="!loading && medias.length > 0">
													<ul>
														<li
															style="display: inline-block"
															v-for="media in medias"
															:key="media._id"
															class="filterMedia"
														>
															<a
																:href="getMediaUrl(media)"
																target="_blank"
																v-if="getMediaSource(media) === selectedSource || selectedSource === 'all'"
																:style="getMediaStyle(media)"
															>
															</a>
														</li>
													</ul>
												</div>
												<div v-if="!loading && medias.length === 0" class="noData">
													<p>No Data to display</p>
												</div>
												<div v-if="loading" class="dynvibeLoading"></div>
											</div>
										</div>
										<div class="row dynvibeRow">
											<div class="col-xs-6">
												<div class="wrapperKeyword">
													<dynvibewordcloud
														ref="ficheProfileKeyword"
														:url-to-get="urlKeyword()"
														title="Keywords"
														:editable="false"
														:clickable="false"
													></dynvibewordcloud>
												</div>
											</div>
											<div class="col-xs-6">
												<div class="wrapperKeyword">
													<dynvibewordcloud
														ref="ficheProfileMastertags"
														:url-to-get="urlMastertags()"
														title="Mastertags"
														:editable="false"
														:clickable="false"
													></dynvibewordcloud>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</transition>
			<!-- </teleport> -->
			<!-- </portal> -->
		</div>
	</div>
</template>

<script>
import dynvibewordcloud from "@/components/vueCharts/DynvibeWordCloud.vue";

export default {
	name: "fiche",
	inject: ["picture_host"],
	props: {
		idprofile: {
			default: "",
		},
		middle: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			showModal: false,
			medias: [],
			filtered: [],
			sources: [],
			selectedSource: null,
			showFiche: false,
			loading: false,
		};
	},
	mounted() {
		this.selectedSource = "all";
		// if (store.getters.admin === 1) {
		this.showFiche = true;
		// }
	},
	components: {
		dynvibewordcloud: dynvibewordcloud,
	},

	methods: {
		urlKeyword() {
			let url = "ficheProfileKeyword?idProfile=" + this.idprofile;
			if (this.selectedSource !== "all") {
				url += "&source=" + this.selectedSource;
			}
			return url;
		},
		urlMastertags() {
			let url = "ficheProfileMastertags?idProfile=" + this.idprofile;
			if (this.selectedSource !== "all") {
				url += "&source=" + this.selectedSource;
			}
			return url;
		},
		getMediaSource(media) {
			return media["media"];
		},
		getMediaUrl(media) {
			return media["url"];
		},
		getMediaPicture(media) {
			let mediaPicture = media["picture"];
			if (media["media"] === "twitter") {
				mediaPicture = mediaPicture.replace("_normal.", "_400x400");
				mediaPicture = mediaPicture.replace("size=bigger", "size=original");
			} else if (media["media"] === "instagram") {
				let shortcode = media["url"].split("/")[4];
				return [mediaPicture, this.picture_host + "img/instagram_images2/" + shortcode + ".jpg"];
			}
			return mediaPicture;
		},
		getMediaStyle(media) {
			let picture = this.getMediaPicture(media);
			if (Array.isArray(picture)) {
				return (
					"background-image:url(" +
					picture[0] +
					"),url(" +
					picture[1] +
					");width: 180px;height: 180px;display: block;background-position: center;background-size: cover;"
				);
			} else {
				return (
					"background-image:url(" +
					picture +
					");width: 180px;height: 180px;display: block;background-position: center;background-size: cover;"
				);
			}
		},
		mediaFilter() {
			if (this.$refs.ficheProfileKeyword) {
				this.$refs.ficheProfileKeyword.changeUrl(this.urlKeyword());
			}
			if (this.$refs.ficheProfileMastertags) {
				this.$refs.ficheProfileMastertags.changeUrl(this.urlMastertags());
			}
		},
		loadModal() {
			this.medias = [];
			this.showModal = true;
			this.loading = true;
			let params = new URLSearchParams();
			params.append("idProfile", this.idprofile);
			if (this.middle === true) {
				params.append("middle", this.middle);
			}
			this.$axios.post(this.$backendUrl + "ficheProfile", params).then((response) => {
				this.sources = response.data.mediasSources;
				if (response.data.medias) {
					this.medias = response.data.medias;
				}
				this.selectedSource = "all";
				// this.mediaFilter();
				this.loading = false;
			});
		},
	},
};
</script>

<style scoped>
.wrapperKeyword {
	min-height: 100px;
}
.wrapperKeyword > #keywordProfile,
.wrapperKeyword > #mastertagProfile {
	width: 100%;
	height: 100%;
	min-height: 400px;
}
.modal-mask {
	position: fixed;
	z-index: 9998;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	display: table;
	transition: opacity 0.3s ease;
}

.modal-wrapper {
	display: table-cell;
	vertical-align: middle;
}

.close {
	outline: 0;
}

.dynvibeBox {
	min-height: 300px;
}

.dynvibeTitleModal {
	padding-bottom: 10px;
	margin-bottom: 0;
}

.rowFilters {
	margin-bottom: 15px;
	margin-top: 15px;
}

.filterMediasButton {
	margin-right: 5px;
}

ul {
	list-style: none;
}

li {
	display: inline-block;
}

.filterMedia {
	margin: 5px;
}
</style>
